import { createTheme } from '@mui/material/styles';
import { aquaRefineCustomTokens, aquaRefinePalette } from './palette';
import { aquaRefineTypography } from './typography';

declare module '@mui/material/styles' {
  interface Theme {
    custom: typeof aquaRefineCustomTokens;
  }
  interface ThemeOptions {
    custom?: typeof aquaRefineCustomTokens;
  }
}

export const aquaRefineTheme = createTheme({
  palette: aquaRefinePalette,
  typography: aquaRefineTypography,
  shape: { borderRadius: 10 },
  custom: aquaRefineCustomTokens,
  components: {
    MuiPaper: {
      defaultProps: { elevation: 0 },
      styleOverrides: { root: { backgroundImage: 'none' } },
    },
    MuiButton: {
      styleOverrides: { root: { boxShadow: 'none' } },
    },
    MuiAppBar: {
      defaultProps: { elevation: 0 },
    },
    MuiChip: {
      styleOverrides: { root: { fontWeight: 700 } },
    },
  },
});
